import axios, { AxiosError } from "axios";
import {
  adminJwtHeader,
  formDataHeader,
} from "@/apps/admin-console/services/apiClient/apiHeader";

const jsonHeader = (): Record<string, string> => ({
  "Content-Type": "application/json",
});
import router from "@/router";

export const adminJwtClient = axios.create({
  withCredentials: false,
  headers: adminJwtHeader(),
});

export const adminJwtClientFile = axios.create({
  withCredentials: false,
  headers: { ...adminJwtHeader(), ...formDataHeader() },
});

export const apiClient = axios.create({
  withCredentials: false,
  headers: jsonHeader(),
});

const responseHandler = (response) => {
  return response;
};

const errorHandler = async (error: AxiosError) => {
  if (error.response?.status === 401) {
    sessionStorage.clear();
    router.go(0);
  }
  return Promise.reject(error);
};

adminJwtClient.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);
